<script>
import UploadFiles from '@/components/ux/upload/Upload-files.vue';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import constants from './constants';

const {
  EDITORS_LIST,
  PHOTO_ART_EDITOR,
  PRODUCT_PAGES,
} = constants;

const b = bem('promo-steps');

export default {
  components: {
    EyeInvisibleOutlined,
    EyeOutlined,
    UploadFiles,
  },
  props: {
    optionSteps: {
      type: Array,
    },
    checkedStep: Object,
    isDisabledStep: Boolean,
    checkedStepValues: Object,
    errors: Object,
    isChangeFullOption: Boolean,
    selectedPromotionalAd: Number,
  },
  data() {
    return {
      isShowMobile: false,
      selectedWizard: null,
      selectedPage: null,
      selectedCollection: null,
      selectedFrame: null,
      selectedPageCollections: [],
      EDITORS_LIST,
      PRODUCT_PAGES,
      PHOTO_ART_EDITOR,
    };
  },
  methods: {
    ...mapActions({
      getProductCollectionsActions: 'products/getProductCollections',
      getOneProductCollectionsActions: 'products/getOneProductCollections',
      clearOneProductCollectionsActions: 'products/clearOneProductCollections',
      getAllProductCollectionsActions: 'products/getAllProductCollections',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    changeCheckedStep(value, option) {
      this.$emit('update:checkedStep', this.isChangeFullOption ? option : value);
    },
    onChange(value, type) {
      const newValue = {
        ...this.checkedStepValues,
        [type]: value,
      };
      this.$emit('update:checkedStepValues', newValue);
    },
    handleChangeOptions(value, type) {
      switch (type) {
        case 'pageCollections': {
          this.clearOneProductCollectionsActions();
          this.selectedCollection = null;
          this.selectedPageCollections = this.productCollections.reduce((acc, collection) => {
            if (collection.pageKey === value) {
              return [...acc, { value: collection.id, label: collection.description }];
            }
            return acc;
          }, []);
          return this.createLink();
        }
        case 'productCollections': {
          this.selectedFrame = null;
          this.getOneProductCollectionsActions(value);
          return this.createLink();
        }
        case 'productFrame': {
          this.productOptions = this.currentProductCollection?.products || []
            .find((item) => item.id === value)?.options || []
            .map((item) => {
              const label = `${item.displayName} ${item.frameSize.name} ${item.frameOrientation} ${item.frameColor.name}`;
              return { value: item.id, label };
            });
          return this.createLink();
        }
        default:
          return this.createLink();
      }
    },
    getOptionListFrames() {
      return (this.currentProductCollection?.products || []).reduce((acc, frame) => {
        if (frame.options && frame.options.length > 0 && !frame.isDeleted) {
          return [...acc, { value: frame.id, label: frame.displayName }];
        }
        return acc;
      }, []);
    },
    createLink() {
      let newLink = '';
      if (this.selectedWizard === PHOTO_ART_EDITOR) {
        const params = [];
        if (this.selectedCollection) {
          params.push(`collection=${encodeURIComponent(this.selectedCollection)}`);
        }
        if (this.selectedFrame) {
          params.push(`frame=${encodeURIComponent(this.selectedFrame)}`);
        }
        if (this.selectedPage) {
          params.push(`pageKey=${encodeURIComponent(this.selectedPage)}`);
        }
        newLink = `${PHOTO_ART_EDITOR}?${params.join('&')}`;
      } else {
        newLink = this.selectedWizard || '';
      }
      this.onChange(newLink, 'href');
    },
    async handleCheckedStepChange() {
      if (this.checkedStepValues.href) {
        const { href } = this.checkedStepValues;
        const url = new URL(`https://${href}`);
        const {
          hostname,
          searchParams,
          search,
        } = url;
        const collection = searchParams.get('collection');
        const frame = searchParams.get('frame');
        const pageKey = searchParams.get('pageKey');
        const isPhotoArtPage = `${hostname}/` === PHOTO_ART_EDITOR;
        this.selectedWizard = `${hostname}/${isPhotoArtPage ? '' : search}`;
        if (isPhotoArtPage) {
          this.selectedPage = pageKey;
          this.selectedCollection = Number(collection);
          await this.getOneProductCollectionsActions(collection);
          this.selectedFrame = Number(frame);
        }
      } else {
        this.selectedWizard = null;
        this.selectedPage = null;
        this.selectedCollection = null;
        this.selectedFrame = null;
      }
    },
  },
  computed: {
    ...mapState({
      productCollections: (state) => state.products.productCollections,
      currentProductCollection: (state) => state.products.currentProductCollection,
      isCurrentProductCollectionLoaded: (state) => state.products.isCurrentProductCollectionLoaded,
      isLoadingProduct: (state) => state.products.isLoading,
    }),
  },
  mounted() {
    this.handleCheckedStepChange();
  },
  watch: {
    selectedPromotionalAd: {
      handler() {
        this.handleCheckedStepChange();
      },
    },
    checkedStep: {
      handler(newVal) {
        if (newVal.value !== this.checkedStep.value) {
          this.handleCheckedStepChange();
        }
      },
    },
  },
};
</script>

<template>
  <div :class="b('row', { center: true })">
<!--    <a-select
        :options="optionSteps"
        :value="checkedStep"
        style="width: 150px"
        :disabled="isDisabledStep"
        @change="changeCheckedStep"
    />-->
    <div :class="b('row', { center: true })">
      <h4>Show this step: </h4>
      <button
          :class="b('field-title-button', { on: !checkedStepValues.hideStep })"
          @click="() => {onChange(!checkedStepValues.hideStep, 'hideStep')}"
      >
        <EyeOutlined />
      </button>
      /
      <button
          :class="b('field-title-button', { on: checkedStepValues.hideStep })"
          @click="() => {onChange(!checkedStepValues.hideStep, 'hideStep')}"
      >
        <EyeInvisibleOutlined />
      </button>
    </div>
  </div>
  <div :class="b('row')" v-if="!checkedStepValues.hideStep">
    <div :class="b('column', {withBorder: true})">
      <div :class="b('switch-wrapper')">
        Show Mobile:
        <a-switch
          :class="b('switcher')"
          v-model:checked="isShowMobile"
          :checked="isShowMobile"
          checked-children="Mobile"
          un-checked-children="Desktop"
        />
      </div>
      <template v-if="isShowMobile">
        <div :class="b('column')">
          <h4>Mobile photo: </h4>
          <UploadFiles
            :is-multiple="false"
            :files="checkedStepValues.mobileImage"
            :on-change="(value) => {
              onChange(value, 'mobileImage')
            }"
          />
          <div :class="b('error')" v-if="errors.mobileImage">
            Load mobile image for banner.
          </div>
        </div>
        <div :class="b('column')" >
          <h4>Title mobile: </h4>
          <a-input
            :class="b('input')"
            placeholder="Enter mobile title text"
            :value="checkedStepValues.textBox1"
            @change="({ target: { value } }) => {onChange(value, 'textBox1')}"
          />
          <div :class="b('error')" v-if="errors.textBox1">
            Enter mobile title text for banner.
          </div>
        </div>
        <div :class="b('column')" >
          <h4>Body text mobile: </h4>
          <a-textarea
            :class="b('input')"
            :rows="5"
            placeholder="Enter mobile body text"
            :value="checkedStepValues.textBox2"
            @change="({ target: { value } }) => {onChange(value, 'textBox2')}"
          />
          <div :class="b('error')" v-if="errors.textBox2">
            Enter mobile body text for banner.
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="b('column')">
          <h4>Desktop photo: </h4>
          <UploadFiles
              :is-multiple="false"
              :files="checkedStepValues.desktopImage"
              :on-change="(value) => {
                onChange(value, 'desktopImage')
              }"
          />
          <div :class="b('error')" v-if="errors.desktopImage">
            Load desktop image for banner.
          </div>
        </div>
        <div :class="b('column')" >
          <h4>Title: </h4>
          <a-input
            :class="b('input')"
            placeholder="Enter title text"
            :value="checkedStepValues.title"
            @change="({ target: { value } }) => {onChange(value, 'title')}"
          />
          <div :class="b('error')" v-if="errors.title">
            Enter title text for banner.
          </div>
        </div>
        <div :class="b('column')" >
          <h4>Body text: </h4>
          <a-textarea
            :class="b('input', { full: true })"
            :rows="5"
            placeholder="Enter body text"
            :value="checkedStepValues.body"
            @change="({ target: { value } }) => {onChange(value, 'body')}"
          />
          <div :class="b('error')" v-if="errors.body">
            Enter body text for banner.
          </div>
        </div>
      </template>
    </div>
    <div :class="b('column', {isRight: true})">
      <div :class="b('row')">
        <div :class="b('column')" >
          <h4>Subtitle: </h4>
          <a-input
              :class="b('input')"
              placeholder="Enter subtitle text"
              :value="checkedStepValues.subtitle"
              @change="({ target: { value } }) => {onChange(value, 'subtitle')}"
          />
          <div :class="b('error')" v-if="errors.subtitle">
            Enter subtitle text for banner.
          </div>
        </div>
      </div>
      <div :class="b('column')">
        <div :class="b('column')" >
          <h4>Disclaimer text: </h4>
          <a-input
            :class="b('input')"
            placeholder="Enter disclaimer text"
            :value="checkedStepValues.disclaimerText"
            @change="({ target: { value } }) => {onChange(value, 'disclaimerText')}"
          />
          <div :class="b('error')" v-if="errors.disclaimerText">
            Enter disclaimer text for banner.
          </div>
        </div>
        <div :class="b('column')" >
          <h4>Button text: </h4>
          <a-input
              :class="b('input')"
              placeholder="Enter button text"
              :value="checkedStepValues.buttonText"
              @change="({ target: { value } }) => {onChange(value, 'buttonText')}"
          />
<!--          <div :class="b('error')" v-if="errors.buttonText">-->
<!--            Enter button text for banner.-->
<!--          </div>-->
        </div>
      </div>
      <div :class="b('row')" v-if="isChangeFullOption">
        <a-select
          :options="EDITORS_LIST"
          style="width: 200px"
          placeholder="Select wizard"
          v-model:value="selectedWizard"
          @change="(value) => handleChangeOptions(value, 'selectedWizard')"
        />
      </div>
      <template
        v-if="selectedWizard === PHOTO_ART_EDITOR && isChangeFullOption"
      >
        <div
          :class="b('row')"
        >
          <a-select
            :options="PRODUCT_PAGES"
            style="width: 200px"
            placeholder="Select page"
            v-model:value="selectedPage"
            @change="(value) => handleChangeOptions(value, 'pageCollections')"
          />
        </div>
        <div
          :class="b('row')"
          v-if="selectedPageCollections && selectedPageCollections.length > 0"
        >
          <a-select
            v-model:value="selectedCollection"
            placeholder="Select collection"
            style="width: 200px"
            :options="selectedPageCollections"
            @change="(value) => handleChangeOptions(value, 'productCollections')"
          />
        </div>
        <div
          :class="b('row')"
          v-if="
            currentProductCollection
            && currentProductCollection.id
            && !isLoadingProduct
          "
        >
          <a-select
            v-model:value="selectedFrame"
            placeholder="Select frame"
            style="width: 200px"
            :options="getOptionListFrames()"
            @change="(value) => handleChangeOptions(value, 'productFrame')"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";
@import "@/styles/fonts";

.promo-steps {
  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    align-items: baseline;

    &_center {
      justify-content: center;
    }

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(10);
      margin-bottom: vw-full(10);
    }
  }

  &__column {
    width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 10px;

    &_isRight {
      width: 45%;
    }
    &_withBorder {
      width: 50%;
      border-right: 1px solid $horizon;
      padding-right: 5%;
    }

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(10);
    }
  }

  &__error {
    color: red;
  }

  &__field-title-button {
    background: none;
    border: none;
    color: rgba($light-slate-gray-color, 0.5);
    cursor: pointer;

    &_on {
      color: $tacao;
    }
  }

  &__input {
    width: 100%;
  }
}
</style>
